"use client";

import User from "@/components/icons/user.svg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { handleShopifyLogout } from "@/lib/shopify/auth/customer-login";
import Image from "next/image";
import Link from "next/link";

export function AccountMenu() {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="flex h-16 items-center border-r-1 border-primary px-6 text-primary focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
            Account
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" align="end">
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <Link href="/account">
              <DropdownMenuItem>Profile</DropdownMenuItem>
            </Link>
            <Link href="/addresses">
              <DropdownMenuItem>Manage Addresses</DropdownMenuItem>
            </Link>
            <Link href="/orders">
              <DropdownMenuItem>Order History</DropdownMenuItem>
            </Link>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleShopifyLogout}>Log out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}

export function AccountMenuMobile() {
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button className="flex items-center text-primary focus:ring-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2">
            <Image src={User} alt="account" className="h-auto w-13"></Image>
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-56" align="end">
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <Link href="/account">
              <DropdownMenuItem>Profile</DropdownMenuItem>
            </Link>
            <Link href="/addresses">
              <DropdownMenuItem>Manage Addresses</DropdownMenuItem>
            </Link>
            <Link href="/orders">
              <DropdownMenuItem>Order History</DropdownMenuItem>
            </Link>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleShopifyLogout}>Log out</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
